module.exports = __webpack_public_path__ + "media/3_33.4387e2c4.wav";